import { createClient } from '@/shared/api';
import type {
  SendCiedComingSoonRequestMutation,
  SendCiedComingSoonRequestMutationVariables,
} from '@/shared/api';
import SEND_CIED_COMING_SOON_REQUEST_MUTATION from '../mutations/sendCiedComingSoonRequest';

/**
 * Registers a clinic's interest in the upcoming CIED capability. Runs SEND_CIED_COMING_SOON_REQUEST_MUTATION and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleSendCiedComingSoonRequest = async (
  input: SendCiedComingSoonRequestMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const result = await client.mutate<
    SendCiedComingSoonRequestMutation,
    SendCiedComingSoonRequestMutationVariables
  >({
    mutation: SEND_CIED_COMING_SOON_REQUEST_MUTATION,
    variables: {
      input,
    },
  });
  const { isSuccess, message } = result.data?.sendCIEDComingSoonRequest || {};
  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
};

export default handleSendCiedComingSoonRequest;
